import styled, { keyframes } from "styled-components";
import { breakpoints } from "../../globalStyles";

export const fade = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const ReleaseCard = styled.li`
  gap: 24px;
  overflow: hidden;
  background-color: var(--card-default);
  padding: 12px 24px 12px 16px;
  cursor: ${({ isPodcastPage }) => !isPodcastPage && "pointer"};
  display: grid;
  grid-template-columns: auto 1fr auto;
  animation: ${fade} ${(props) => props.duration + "ms"} forwards;
  animation-timing-function: cubic-bezier(0 0 0.58 1);
  animation-delay: 100ms;
  border-radius: 12px;
  opacity: 0;
  position: relative;
  cursor: pointer;

  @media (hover: hover) and (pointer: fine) {
    :hover {
      background-color: var(--card-hover);
    }
  }

  @media (max-width: 500px) {
    background-color: inherit;
    align-items: start;
    justify-content: end;
    padding: 0;
    padding-bottom: 5px;
    padding-right: 13px;
    column-gap: 12px;
    border-radius: 0;
    row-gap: 0;

    ${({ isPodcastPage }) =>
      isPodcastPage &&
      `
      border-bottom: 1px solid #515151;
    `};

    ${({ showPodcastInfo }) =>
      !showPodcastInfo &&
      `
         padding: 14px 16px 26px 16px;
      `}
  }

  ${({ showPodcastInfo }) =>
    !showPodcastInfo &&
    ` 
      padding: 16px 38px 16px 24px;
    `}
`;

export const PodcastImg = styled.img`
  width: 54px;
  aspect-ratio: 1/1;
  grid-row: 1/2;
  z-index: 2;
  border-radius: 8px;
  object-fit: cover;

  @media (max-width: 500px) {
    width: 64px;
    grid-column: 1/2;
  }
`;

export const ReleaseTitle = styled.span`
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-height: 24px;
  -webkit-box-orient: vertical;

  @media (max-width: 500px) {
    -webkit-line-clamp: 2;
  }
`;

export const ReleaseInfo = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  @media (max-width: 500px) {
    flex-direction: column;
    align-items: baseline;
    gap: 4px;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const ReleaseBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  justify-content: center;
  z-index: 2;

  @media (max-width: 500px) {
    grid-column: 1/3;
    grid-row: 1/2;
    gap: 2px;

    ${({ showPodcastInfo }) =>
      showPodcastInfo &&
      `
        padding-left: 76px;
      `}
  }
`;

export const ReleaseButtons = styled.div`
  display: grid;
  ${({ showLikeBtn }) =>
    showLikeBtn
      ? `grid-template-columns: 1fr 1fr;`
      : `grid-template-columns: 1fr;`}

  align-items: center;

  ${({ showPodcastInfo }) =>
    !showPodcastInfo &&
    `
    grid-column: 3/4;
  `}

  @media (max-width: 500px) {
    grid-template-columns: 1fr;
    gap: 0;
  }

  @media (max-width: 500px) {
    /* Не хочу удалять, есть ощущение, что дизайн могут поменять обратно */
    /* grid-column: 1/3;
    grid-template-columns: auto auto 1fr;
    padding: 0 16px;
    gap: 51px;
    padding-top: 26px; */
  }
`;

export const ReleaseDuration = styled.span`
  white-space: nowrap;
`;

export const ReleaseDate = styled.span`
  grid-row: 1/2;
  color: #919191;
  font-weight: 600;
  line-height: 150%;
`;

export const ReleaseLive = styled.p`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const Dot = styled.span`
  @media (max-width: 500px) {
    display: none;
  }
`;

export const ReleasePlay = styled.div`
  position: relative;

  @media (max-width: 500px) {
    display: none;
  }
`;

export const CircleShadow = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) scale(1);
  width: 14px;
  aspect-ratio: 1/1;
  border-radius: 100%;
  background: linear-gradient(90deg, #222222 15%, #313131 25%, #363636 100%);
  opacity: 0.3;
  transition: all 0.3s ease-in;

  ${({ circleWidth, showShadow }) =>
    circleWidth &&
    showShadow &&
    `
      transform: translate(-50%, -50%) scale(${circleWidth / 7.8});
      opacity: 1;

      @media ${breakpoints.xs} {
        background: linear-gradient(90deg, #222222 30%, #313131 40%, #363636 100%);
      }   

      @media (max-width: 500px) {
         transform: translate(-50%, -50%) scale(${circleWidth / 7.3});
         background: linear-gradient(70deg, #222222 60%, #313131 70%, #363636 100%);
         transition: all .35s ease-in;
      }
  `}
`;
